module.exports = __webpack_public_path__ + "static/media/Y240.d06eeac5.jpg";